/* eslint-disable */
import $ from 'jquery';
/* eslint-enable */

export default function () {
  /* Javascript for the mobile toggle button */
  $('.ajax-navbar-mobile-toggle').click(() => {
    $('.ajax-navbar-container').toggleClass('open');
  });
}
